// PRD.325 — the Form Header, rendered identically on all three surfaces.
//
// ONE renderer for Map Fields, Preview and the patient Render, so a header
// cannot look like three different things. Colour and size come from the shared
// semantic tables in data-access; nothing here hardcodes a palette.

import {
  FORM_HEADER_COLOR_VALUES,
  FORM_HEADER_SIZE_PX,
  resolveFormHeaderText,
  type FormHeaderConfig,
} from '@helios/data-access';

export function FormHeaderBox({
  config,
  formName,
  scale = 1,
}: {
  config: FormHeaderConfig;
  /** Current definition name — resolved live, never snapshotted. */
  formName: string | null | undefined;
  /**
   * Multiplier for the builder's smaller canvas, so the header keeps its
   * relative weight there instead of dwarfing a scaled-down page.
   */
  scale?: number;
}) {
  const text = resolveFormHeaderText(config, formName);
  if (!text) return null;

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        // Vertically centred within its authoritative rectangle.
        alignItems: 'center',
        justifyContent:
          config.alignment === 'left'
            ? 'flex-start'
            : config.alignment === 'right'
              ? 'flex-end'
              : 'center',
        // Long names WRAP rather than painting outside the rectangle or being
        // silently truncated. If the text needs more vertical room than the box
        // has, it visibly overflows downward in the builder and Preview — which
        // is the signal to make the box taller, and deliberately not something
        // that alters PRD.324 pagination.
        overflowWrap: 'anywhere',
        textAlign: config.alignment,
        lineHeight: 1.2,
        fontWeight: 700,
        fontSize: FORM_HEADER_SIZE_PX[config.size] * scale,
        color: FORM_HEADER_COLOR_VALUES[config.color],
      }}
    >
      <span style={{ width: '100%' }}>{text}</span>
    </div>
  );
}
